// @flow
export const NAVBAR_HEIGHT = 49
export const NAVBAR_HEIGHT_FREEDELIVERYMESSAGE = 98
export const DRAWER_HOME_PADDING = 40
export const CONTAINER_MAX_WIDTH = 1200
export const CONTAINER_PADDING = 18
export const DRAWER_WIDTH = 300
export const DEFAULT_FONT_SIZE = 16
export const INFO_PANEL_FONT_SIZE = 12
export const POWERED_BY_FONT_SIZE = 10

const getMaxWidth = viewport => {
  switch (viewport) {
    case 'md':
      return 828
    case 'lg':
      return 1180
    case 'xl':
      return 1480
    default:
      return 1200
  }
}

const leftPosition = (width: string, isAtHomePage: boolean) => {
  if (isAtHomePage) {
    return window.innerWidth > getMaxWidth(width)
      ? (window.innerWidth - getMaxWidth(width)) / 2
      : 0
  } else {
    return window.innerWidth > CONTAINER_MAX_WIDTH
      ? (window.innerWidth - CONTAINER_MAX_WIDTH) / 2
      : 0
  }
}

const topPosition = (freeDeliveryMessage, isAtHomePage, width) => {
  if (isAtHomePage) {
    switch (width) {
      case 'md':
        return NAVBAR_HEIGHT + 16
      case 'lg':
        return NAVBAR_HEIGHT + 24
      case 'xl':
        return NAVBAR_HEIGHT + 40
      default:
        return 0
    }
  } else {
    return freeDeliveryMessage
      ? NAVBAR_HEIGHT_FREEDELIVERYMESSAGE
      : NAVBAR_HEIGHT
  }
}

export default {
  hamburger: {
    display: 'flex',
    marginRight: 16
  },
  drawerContainer: (
    freeDeliveryMessage: boolean,
    background: string,
    isOpen: boolean,
    width: string,
    isAtHomePage: boolean
  ) => ({
    width: DRAWER_WIDTH,
    position: 'fixed',
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
    left: leftPosition(width, isAtHomePage),
    top: topPosition(freeDeliveryMessage, isAtHomePage, width),
    background: background,
    transition: '0.75s',
    height: '100%',
    paddingLeft: 32,
    boxSizing: 'border-box'
  }),
  drawerChild: {
    position: 'relative',
    maxWidth: '100%',
    paddingLeft: CONTAINER_PADDING
  },
  anchor: (color: string) => ({
    textDecoration: 'none',
    color
  }),
  text: (color: string, fontSize: number) => ({
    color,
    fontSize: fontSize
  }),
  seeAllProducts: {
    marginTop: 24,
    marginBottom: 6
  },
  seeAllProductsText: (color: string) => ({
    marginTop: 24,
    fontWeight: 'bold',
    fontSize: DEFAULT_FONT_SIZE,
    textTransform: 'uppercase',
    color
  }),
  info: (color: string) => ({
    color,
    fontWeight: 'bold',
    fontSize: 16,
    textTransform: 'uppercase',
    cursor: 'pointer',
    marginTop: 16
  }),
  collapse: {
    marginBottom: 24
  }
}
